import { render, staticRenderFns } from "./ProductVariants_comp.vue?vue&type=template&id=bca3bc94&scoped=true&"
import script from "./ProductVariants_comp.vue?vue&type=script&lang=js&"
export * from "./ProductVariants_comp.vue?vue&type=script&lang=js&"
import style0 from "./ProductVariants_comp.vue?vue&type=style&index=0&id=bca3bc94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bca3bc94",
  null
  
)

export default component.exports